// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1ie3e","item":"PaymentsMobile_item__3HKWo","label":"PaymentsMobile_label__UcQfG","amount":"PaymentsMobile_amount__1DAu5"};